import { FormElement, Schema, Section } from '.';

/* istanbul ignore file */
export class SmartsForm {
    Schema?: Schema;
    Sections?: Section[];
    UISchema?: FormElement;
}
